module.exports = __webpack_public_path__ + "static/commander_logo-b23af638a07603415ce57b8884bef66a.png";